interface ShopComponentsConfig {
  moduleID?: string;
  countryCode?: string;
  eventName?: string;
  ignore?: boolean;
}

export type Storage = typeof globalThis & {
  __ShopComponentsConfig?: ShopComponentsConfig;
  isDevMode?: boolean;
};

export const storage: typeof globalThis =
  typeof window !== 'undefined' ? window : globalThis;

export const getConfig: () => ShopComponentsConfig = () => {
  const _storage: Storage = storage;

  if (!_storage.__ShopComponentsConfig) {
    _storage.__ShopComponentsConfig = {
      countryCode: 'us',
      moduleID: 'shop-components',
      eventName: 'SHOP-COMPONENTS::EVENT-TRACKING',
    };
  }

  return _storage.__ShopComponentsConfig;
};

export const setEventTrackingConfig = (opts: ShopComponentsConfig) => {
  (storage as Storage).__ShopComponentsConfig = {
    ...getConfig(),
    ...opts,
  };
};
